import { EmployeeOptionsType, IWorkForceUserEntity } from "./globals";
import { IOptionsType } from "./project-register.interface";
import { IWorkspace } from "./workspace.interface";

import {
  TGetSingleEmployee,
  T_EmployeeWorkInfoSchemaResponse,
  TdeclarationSchema,
  TemployeeImportantInfoResponse,
} from "@/schemas/employee-schema";

export enum YesNo {
  "Yes" = "YES",
  "No" = "NO",
}

export enum Relationship {
  "Spouse" = "SPOUSE",
  "Child" = "Child",
}

export type TApprovedStatus = "REJECTED" | "APPROVED" | "VERIFIED";

export type TOnboardingStatus = string;

interface IEmergencyDetails {
  name?: string;
  address?: string;
  phoneNumber?: string;
  relationship?: Relationship;
}

interface IPreviousExperience {
  skills?: string[];
  textField?: string;
}

interface IEmploymentType {
  desiredRole?: string;
  whiteCardNo?: string;
  describesYou?: string;
  taxFileNumber?: string;
  passportNumber?: string;
  driversLicenseNo?: string;
}

interface IEmploymentSeeking {
  desiredRole?: string;
  transportMethod?: string;
  proposedStartDate?: string;
}

interface ISuperAnnuationDetails {
  bankName?: string;
  membershipNumber?: string;
}

export interface TrainingEntity {
  name: string;
  ticketUrl: string;
  expiryDate: string;
  issuedDate: string;
}
interface IWorkInfo {
  trainings?: TrainingEntity[];
  employmentType?: IEmploymentType;
  referenceDetails?: string;
  employmentSeeking?: IEmploymentSeeking;
  previousExperience?: IPreviousExperience;
}

interface IBankDetails {
  bsb?: string;
  bankName?: string;
  accountNumber?: string;
}

interface IBasicInfo {
  bankDetails?: IBankDetails;
  emergencyDetails?: IEmergencyDetails;
  superAnnuationDetails?: ISuperAnnuationDetails;
}

interface IHealthDetails {
  medicalDetails?: string;
  medicalFitness?: YesNo;
}

interface ICriminalConviction {
  chargeDetails?: string;
  pendingCharges?: YesNo;
}

interface IWorkerCompensation {
  compensationDetails?: string;
  workerCompenstation?: YesNo;
}

interface IDeclaration {
  signature?: string;
  healthDetails?: IHealthDetails;
  covidVaccinated?: YesNo;
  criminalConviction?: ICriminalConviction;
  workerCompensation?: IWorkerCompensation;
}

export type IEmployeeUser = IWorkForceUserEntity;

export interface IEmployee {
  id: string;
  workspaceId?: string;
  userId?: string;
  onboardingStatus?: TOnboardingStatus;
  approvedStatus?: TApprovedStatus;
  basicInfo?: IBasicInfo;
  whiteCardNo?: string;
  // workInfo?: IWorkInfo;
  workInfo?: T_EmployeeWorkInfoSchemaResponse;
  declaration?: IDeclaration;
  user?: IEmployeeUser;
  workspace?: IWorkspace;
}

export interface User {
  id: string;
  createdAt: string;
  updatedAt: string;
  email: string;
  phoneNumber: string;
  status: string;
  firstName: string;
  middleName: string;
  lastName: string;
  address: string;
  image: string;
  permissions: object;
  role: string;
  employmentType: string;
}

export interface ITermination {
  id: string;
  workspaceId: string;
  userId: string;
  onboardingStatus: string;
  approvedStatus: string;
  basicInfo: IBasicInfo;
  workInfo: IWorkInfo;
  declaration: IDeclaration;
  user: User;
}

export interface IEmployeeOptionsList extends Omit<IOptionsType, "for"> {
  for: EmployeeOptionsType;
}

export type ItemProps = {
  id?: string;
  action?: string;
  actionDetails: {
    terminationDate: string | Date;
    terminationReason: string;
    severancePay: string;
    employeeEvaluation: {
      attendance: string;
      initiative: string;
      cooperation: string;
      workQuality: string;
      jobKnowledge: string;
    };
    rehireRecommendation: string;
    additionalComment: string;
    employeeNotice: {
      date: string | Date;
    };
  };
  actor: {
    firstName: string;
    middleName?: string;
    lastName: string;
    phoneNumber: string;
  };
};

export type IEmployeeDetails = TGetSingleEmployee & {
  declaration: TdeclarationSchema;
  importantInfo: TemployeeImportantInfoResponse;
};
